import trackingService from "@irati/utils/tracking"
import {ContentCardTrackingSource} from "./enums"

interface ContentCardTracking {
  openLink(
    url: string,
    source: ContentCardTrackingSource,
    perkbox_product: string,
    entity_id: string,
    campaign_name: string,
    unread: boolean,
    type: string
  ): void,
  openNotification(source: string): void
}

const tracking: ContentCardTracking = {
  openLink(url, source, perkbox_product, entity_id, campaign_name, unread, type) {
    const data = {url, source, perkbox_product, entity_id, campaign_name, unread, type}
    trackingService.trackPlatformEvent("contentCard_click", data)
  },
  openNotification(source: string) {
    const data = {source}
    trackingService.trackPlatformEvent("contentCard_view", data)
  }
}

export default tracking
